/** Labels from public/config/descriptions.json (flat keys, e.g. theme.colors.primary). */
export function getDescriptionForPath(descriptions, key, fallbackKey) {
  if (!descriptions || typeof descriptions !== 'object') return key;
  const d = descriptions[fallbackKey];
  if (typeof d === 'string' && d.trim()) return d.trim();
  return key;
}